import React, { Component } from 'react';
import interiorDesign from '../img/i.d_logo.jpg';
import AtlantaHomes from '../img/AHandLlogo.jpg';
import ASID from '../img/ASID-Design-Excellence-Award-certificate-logo-only.jpg';
import styleBlueprint from '../img/style-blueprint.jpg';
import ModernLuxury from '../img/modern-luxury-interiors.jpg';
import Voyage from '../img/voyageATL.jpg';
import '../styles/press.css';

class PressPage extends Component {
  render() {
    return (
      <div className="pressContainer">
        <div className="pressList">
          <h5>SOME OF MY WORK THAT HAS BEEN AWARDED OR FEATURED:</h5>
          <img src={Voyage} alt="Voyage ATL" />
          <img src={ModernLuxury} alt="Modern Luxury Interiors Atlanta" />
          <img src={styleBlueprint} alt="Style Blueprint" />
          <img src={ASID} alt="ASID Design Excellence" />
          <img src={AtlantaHomes} alt="Atlanta Homes and Lifestyles" />
          <img src={interiorDesign} alt="Interior Design" />
        </div>
      </div>
    );
  }
}

export default PressPage;



// WEBPACK FOOTER //
// ./src/containers/press.js